module.exports = __webpack_public_path__ + "static/media/grant.c4da2844.jpg";